// src/components/Admin/QuestionsList.js
import React, { useState } from 'react';

const QuestionsList = ({ questions, renderDesktopRow, renderMobileCard, tableHead, hidePendingToggle }) => {
  const [showPendingOnly, setShowPendingOnly] = useState(false);

  const handleTogglePending = () => {
    setShowPendingOnly(prev => !prev);
  };

  // Filter the questions for mobile view if needed.
  const mobileQuestions = showPendingOnly
    ? questions.filter(q => q.status === "Pending")
    : questions;

  return (
    <>
      {/* Desktop Table View */}
      <div className="desktop">
        <div className="row">
          <div className="col-xs-12">
            <div className="card table">
              <table>
                {tableHead && <thead>{tableHead}</thead>}
                <tbody>
                  {questions.map((q, index) => renderDesktopRow(q, index))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Card View */}
      <div className="mobile container-fluid">
        <div className="row">
          <div className="col-xs-12">
            {!hidePendingToggle && (
              <button
                className="text-link full-width margin-bottom-xl margin-top-l"
                onClick={handleTogglePending}
              >
                {showPendingOnly ? "Show All" : "Show Pending Only"}
              </button>
            )}
          </div>
        </div>
        <div className="row">
          {mobileQuestions.map((q) => (
            <div className="col-xs-12" key={q._id || q.id}>
              {renderMobileCard(q)}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default QuestionsList;
